import ModeEditIcon from '@mui/icons-material/ModeEdit';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ControlPointDuplicateIcon from '@mui/icons-material/ControlPointDuplicate';
export const AssessmentDetailsTableColumn = ({ setOpenModalName, setModalExtraData }) => [
  {
    field: 'slNo',
    headerName: 'Sl No.',
    width: 80,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'trainerName',
    headerName: 'Tutor Name',
    width: 220,
  },
  {
    field: 'studentName',
    headerName: 'Student Name / Admn. No.',
    width: 220,
  },
  {
    field: 'croName',
    headerName: 'CRO Name',
    width: 160,
  },
  {
    field: 'courseName',
    headerName: 'Course',
    width: 180,
  },
  {
    field: 'subjectName',
    headerName: 'Subject',
    width: 140,
  },
  {
    field: 'examinationType',
    headerName: 'Examination Name',
    width: 180,
  },
  {
    field: 'totalSessions',
    headerName: 'Total Session',
    width: 180,
  },
  {
    field: 'examination_date',
    headerName: 'Exam Date',
    width: 140,
  },
  {
    field: 'student_examination_updated_on',
    headerName: 'Created Date',
    width: 180,
  },
  {
    field: 'action',
    headerName: 'Actions',
    width: 250,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    renderCell: ({ row }) => (
      <Box display={'flex'} gap={1}>
        <Button
          variant="outlined"
          startIcon={<ModeEditIcon />}
          onClick={() => {
            setModalExtraData(row);
            setOpenModalName('Edit Assessment');
          }}
        >
          Edit
        </Button>
        <Button
          variant="outlined"
          color="info"
          startIcon={<ControlPointDuplicateIcon />}
          onClick={() => {
            setModalExtraData(row);
            setOpenModalName('Duplicate Assessment');
          }}
        >
          Duplicate
        </Button>
      </Box>
    ),
  },
];
